<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-container fluid>
        <v-expand-transition>
            <!-- 場所未選択状態 -->
            <v-card v-if="targetPlace == null" class="green lighten-5 pa-1">
                <Title title="圃場の管理">
                    <v-spacer />
                    <TitleButton
                        color="primary"
                        icon="mdi-home-city"
                        name="新規圃場"
                        @click="onClickAddNewPlace" />
                    <TitleButton
                        color="primary"
                        icon="mdi-group"
                        name="新規グループ"
                        @click="onClickAddNewGroup" />
                </Title>
                <v-container fluid class="pa-0">
                    <!-- グループに未所属の場所 -->
                    <v-row>
                        <template v-for="place in places">
                            <v-col 
                                xs="12" sm="4" md="3" lg="2" xl="2" cols="12"
                                v-if="(place.body.placeGroupID == null || place.body.placeGroupID == '') && canBrowsePlace(place)" 
                                :key="place.body.placeID">
                                <PlaceCard
                                    :place="place"
                                    :isShareMode="isShareMode"
                                    @onClickPlace="onClickPlace"
                                    @onSelectedMenu="onSelectedPlaceMenu" />
                            </v-col>
                        </template>
                    </v-row>
                    <!-- グループに所属している場所 -->
                    <v-row>                    
                        <v-col v-for="group in groups" :key="group.placeGroupID" cols="12">
                            <v-expansion-panels class="mb-1">
                                <v-expansion-panel>
                                    <v-expansion-panel-header >
                                        <v-toolbar dense flat height="24">
                                            <v-icon class="mr-1">mdi-home-group</v-icon>
                                            <span>{{group.name}}</span>
                                            <v-spacer />
                                            <v-btn icon color="primary" @click.stop="onClickEditGroup(group)">
                                                <v-icon>mdi-pencil</v-icon>
                                            </v-btn>
                                        </v-toolbar>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-container fluid class="pa-0">
                                            <v-row>
                                                <template v-for="place in places">
                                                    <v-col 
                                                        xs="12" sm="6" md="4" lg="3" xl="2" cols="12"
                                                        v-if="place.body.placeGroupID != null && place.body.placeGroupID == group.placeGroupID && canBrowsePlace(place)" 
                                                        :key="place.body.placeID">
                                                        <PlaceCard
                                                            :place="place"
                                                            :isShareMode="isShareMode"
                                                            @onClickPlace="onClickPlace"
                                                            @onSelectedMenu="onSelectedPlaceMenu" />
                                                    </v-col>
                                                </template>
                                            </v-row>
                                        </v-container>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>

                            <!-- <v-card class="pa-1">
                                <Title :title="group.name">
                                    <v-spacer />
                                    <TitleButton
                                        color="primary"
                                        icon="mdi-pencil"
                                        name="グループ編集"
                                        @click="onClickEditGroup(group)" />
                                </Title>
                                <v-container fluid>
                                    <v-row>
                                        <template v-for="place in places">
                                            <v-col 
                                                xs="12" sm="6" md="4" lg="3" xl="2" cols="12"
                                                v-if="place.body.placeGroupID != null && place.body.placeGroupID == group.placeGroupID && (!isShareMode || mi_checkGroupUserAuthority(place.body, ['browse']))" 
                                                :key="place.body.placeID">
                                                <PlaceCard
                                                    :place="place"
                                                    :isShareMode="isShareMode"
                                                    @onClickPlace="onClickPlace"
                                                    @onSelectedMenu="onSelectedPlaceMenu" />
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-container>
                            </v-card> -->
                        </v-col>
                    </v-row>
                </v-container>
            </v-card>
            <!-- 場所選択時 -->
            <Place 
                v-else 
                v-model="targetPlace" 
                :workTypes="workTypes" 
                :measureItems="measureItems"
                :composts="composts"
                :fertilizeries="fertilizeries"
                :pesticides="pesticides" />
        </v-expand-transition>
        <Confirm ref="confirm" />
        <PlaceMaintenance ref="placeMaintenance" :places="places" :groups="groups" :crops="crops" :cultivationTypes="cultivationTypes" @onUpdatedPlace="onUpdatedPlace" @onAddNewCultivationType="onAddNewCultivationType" />
        <Group ref="group" :groups="groups" />
    </v-container>
</template>

<script>
    import db from '@/firebase/firestore.js'
    import Title from '@/components/seedling/items/TitleBar'
    import TitleButton from '@/components/tools/TitleBarButton';
    import PlaceMaintenance from '@/components/place/MaintenancePlace';
    import PlaceCard from '@/components/place/PlaceCard';
    import Place from '@/components/place/Place';
    import Group from '@/components/place/MaintenancePlaceGroup';
    import Confirm from '@/components/tools/ConfirmDialog';
    export default {
        components: {
            Title,
            TitleButton,
            PlaceMaintenance,
            PlaceCard,
            Place,
            Group,
            Confirm
        },
        data: function () {
            return {
                /** ユーザーの圃場データ */
                placeData: null,
                // 登録されている全てのグループ
                groups: [],
                // 登録されている全ての場所
                places: [],
                // 選択された場所
                targetPlace: null,
                // 登録されている全作業種類
                workTypes: [],
                // 登録されている全測定項目
                measureItems: [],
                // 登録されている全栽培区分
                cultivationTypes: [],
                // 登録されている全堆肥
                composts: [],
                // 登録されている全肥料
                fertilizeries: [],
                // 登録されている全農薬
                pesticides: [],
                // ======================
                // 登録されている全作物
                // crops: [{
                //     body: crop,
                //     varieties: []
                // }]
                crops: [],
            }
        },
        computed: {
            /**
             * ログインしているユーザーのユーザーUID
             */
            loggedInUserUID: function () {
                return this.$store.getters["loggedInUserUID"]
            },
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /**
             * 共有モード
             */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /**
             * 共有モードの全種類
             */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
            /**
             * 指定された場所の参照を行えるか否か
             */
            canBrowsePlace: function () {
                return function (place) {
                    const self = this
                    if (!this.isShareMode) {
                        return true
                    }

                    const groupAuthorities = place.authorities.find((v)=>v.ownerUserUID == self.shareUserGroupMyUserData.ownerUserUID && v.groupNo == self.shareUserGroupMyUserData.groupNo)
                    const userAuthorities = groupAuthorities != null ? groupAuthorities.users[self.loggedInUserUID] : null

                    console.log("canBrowsePlace", place, self.shareUserGroupMyUserData, self.loggedInUserUID, groupAuthorities, userAuthorities)

                    if (userAuthorities != null) {
                        if (userAuthorities.findIndex((v)=>v == "browse") >= 0) {
                            return true
                        } else {
                            return false
                        }
                    }

                    if (this.mi_checkGroupUserAuthority(place.body, ['browse'])){
                        return true
                    }
                    return false
                }
            }
        },
        created: async function () {
            // console.log("PlaceManager", "created")
            const userUID = this.$store.getters["userUID"]
            const self = this

            this.placeData = !this.isShareMode ? this.$store.getters["managementItems/loggedInUserPlaceData"] : this.$store.getters["managementItems/groupUserPlaceData"]

            this.places = this.placeData.places
            this.groups = this.placeData.groups
            // this.workTypes = placeData.workTypes
            this.measureItems = []
            this.cultivationTypes = this.placeData.cultivationTypes
            this.composts = []
            this.fertilizeries = []
            this.pesticides = []
            this.crops = this.placeData.crops

            try {
            } catch (error) {
                console.log(error)
            }
        },
        methods: {
            // ==================================
            // 作業選択時
            onSelectedWork: function (work) {
                this.$refs.work.show(this.targetPlace, work)
            },
            // ==================================
            // 場所押下時
            // place: {
            //     body:
            //     works: null
            // }
            onClickPlace: function (place) {

                // スクロールを先頭に戻す
                window.scrollTo(0, 0)

                // 作業種類
                this.workTypes = this.createWorkTypes(place)

                // console.log("onClickPlace", place)
                const userUID = this.$store.getters["userUID"]
                const self = this

                // 選択された場所で、登録済みの全測定項目取得
                this.measureItems = []
                db.collection("users").doc(userUID).collection("places").doc(""+place.body.placeID).collection("environments").get().then(function(snapShot){
                    if (snapShot.size > 0) {
                        snapShot.forEach(function(doc){
                            const item = {
                                body: doc.data(),
                                viewAxis: 1,
                                isVisible: true,
                                histories: {}
                            } 
                            
                            self.measureItems.push(item)
                        })
                    }
                }).catch (function(error) {
                    self.mi_writeLog("PlaceManager/onClickPlace", "全測定項目取得に失敗("+error+")")
                })

                // 対象の場所を設定
                this.targetPlace = place
            },
            // ==================================
            // 場所のメニュー項目選択時
            onSelectedPlaceMenu: function (place, menu) {
                console.log("onSelectedPlaceMenu", place, menu)
                const self = this
                switch (menu) {
                    case "edit":
                        this.$refs.placeMaintenance.show(place.body)
                        break;
                    case "delete":
                        this.$refs.confirm.show({
                            title: "圃場の削除",
                            message: "この圃場を削除しますか？<br/>削除すると、この場所で行われた作業記録、環境記録等の全てが削除されます。<br/>※削除後は元に戻す事は出来ません。",
                            buttonYes: "削除する",
                            buttonNo: "いいえ",
                            icon: "mdi-alert",
                            width: 500,
                            listenerYes: function () {
                                self.deletePlace(place)
                                return true
                            },
                        })
                        break;
                }
            },
            // // ==================================
            // // 場所の編集ボタン押下時
            // // place: {
            // //     body:
            // //     works: []
            // // }
            // onClickEditPlace: function (place) {
            //     this.$refs.placeMaintenance.show(place.body)
            // },
            // ==================================
            // グループの編集ボタン押下時
            onClickEditGroup: function (group) {
                this.$refs.group.show(group)
            },
            // ==================================
            // 新規場所ボタン押下時
            onClickAddNewPlace: function () {
                this.$refs.placeMaintenance.show()
            },
            // ==================================
            // 新規グループボタン押下時
            onClickAddNewGroup: function () {
                this.$refs.group.show()
            },
            // ==================================
            // 場所が登録/更新された時
            // place ... 場所レコード(※他と違うので注意！)
            onUpdatedPlace: function (place) {
                // console.log("onUpdatedPlace", place)
                const self = this
                const index = this.places.findIndex((v)=>v.body.placeID == place.placeID)

                if (index < 0) {
                    this.$store.commit(
                        "managementItems/addUserPlace",
                        {
                            userUID: this.$store.getters["userUID"],
                            placeData: this.placeData, 
                            place: place
                        }
                    )
                }

                // if (index < 0) {
                //     this.places.push(
                //         {
                //             body: place,
                //             works: null,
                //             agrichemicals: null,
                //             agrichemicalsHistory: null
                //         }
                //     )
                // }
                // // this.places.splice(index, 1)
                // // this.places.splice(index, 0, place)
            },
            onAddNewCultivationType: function (cultivationType) {
                this.cultivationTypes.push(cultivationType)
            },
            /**
             * システムとユーザーの作業種類をあわせた作業種類の配列を作成
             */
            createWorkTypes: function (place) {
                console.log("createWorkTypes", place)
                const workTypes = []
                for (var i=0; i<place.workTypes.length; i++) {
                    workTypes.push(place.workTypes[i])
                }
                for (var i=0; i<place.userWorkTypes.length; i++) {
                    workTypes.push(place.userWorkTypes[i])
                }
                return workTypes
            },
            /**
             * 場所の削除(※削除のフラグを立てるだけ)
             */
            deletePlace: function (place) {
                const userUID = this.$store.getters["userUID"]
                const self = this
                db.collection("users").doc(userUID)
                .collection("places").doc(place.body.placeID+"")
                .update(
                    {
                        "isDeleted": true,
                        "updater.userUID": this.$store.getters["loggedInUserUID"],
                        "updater.dateTime": this.df_currentDateTime()
                    }
                ).then(function(){
                    self.$store.commit("notification", {message:"場所を削除しました。", isError:false})
                    const index = self.placeData.places.findIndex((v)=>v.body.placeID == place.body.placeID)
                    self.placeData.places.splice(index, 1)
                }).catch (function(error){
                    console.log(error)
                    self.$store.commit("notification", {message:"場所の削除に失敗しました。("+error+")", isError:false})                    
                    self.mi_writeLog("PlaceManager/deletePlace", "場所の削除に失敗しました。("+error+")")
                })
            }
        }
    }
</script>
